interface NotificationSettings {
  email: {
    value: boolean;
  };
  telegram: {
    value: boolean;
  };
}

interface NotificationSettingsData {
  frontEndKey: string;
  title: string;
  notificationType: string;
  notificationValue: boolean | NotificationSettings;
}

interface GetNotificationsSettingsResponse {
  data: NotificationSettingsData[];
  msg: string;
}

enum NotificationSettingsTypes {
  personal = "personal",
  business = "business",
  account = "account",
}

export default NotificationSettingsTypes;
export type {
  GetNotificationsSettingsResponse,
  NotificationSettings,
  NotificationSettingsData,
};
